export class TipoContrato {
	id: number;
	descricao: string;
	idInstituicao: number;
	usuarioAlteracao: number;
}